/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// You can delete this file if you're not using it
import React from 'react';
import WalletContextProvider from './src/components/WalletContextProvider';
import * as Sentry from "@sentry/gatsby";

export const wrapRootElement = ({ element }) => {
    return <WalletContextProvider>{element}</WalletContextProvider>;
};


Sentry.init({
  dsn: "https://ecee33268526cf691926846b47b505d7@o4505929715679232.ingest.sentry.io/4505929717448704",
  integrations: [new Sentry.Replay()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});